import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { OutletFormCreate } from '@/features/outlet/components/outlet-form'

export const Route = createFileRoute('/_app/settings/outlet/create')({
	component: Component,
})

function Component() {
	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/settings', 'Pengaturan'],
					['/settings/outlet', 'Outlet'],
					['/settings/outlet/create', 'Tambah Outlet'],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header title="Tambah Outlet" />
				<OutletFormCreate />
			</PageCard.Root>
		</PageLayout.Root>
	)
}
